import { DTOPerformaceCapture } from '@shared/utils/performance/dto_performance_capture';
import { ILogMessageParams } from './i_log_message_params';

export class ConstantsLogger {
  static readonly COLORS = [
    '#2ecc71', // Green
    '#9b59b6', // Purple
    '#ecf0f1', // Light Gray
    '#95a5a6', // Gray
    '#f8c291', // Peach
    '#38ada9', // Aqua Green
    '#60a3bc', // Muted Blue
    '#78e08f', // Light Green
    '#079992', // Deep Teal
  ];

  static readonly COLOR_ERROR = '#ff0000';
  static readonly COLOR_NOT_IMPORTANT = '#0c0a09';
  static readonly COLOR_WARNING = '#e58e26';

  static ENABLE_LOG_SIZE: boolean = false;

  static readonly PARAMS_DEFAULT: ILogMessageParams = {
    log_time_diff_show: false,
    performance_capture: DTOPerformaceCapture.CREATE_STUB(),
    connection_id: '',
    client_id: '',
    bytes: 0,
    bytes_reference: 0,
  };

  //in ms
  static readonly LOG_DIFF_REFERENCE = 1000;

  //in bytes
  static readonly BYTES_NETWORK_DATA_REFERENCE = 1024 * 1024;

  static readonly LOGGER_COLUMN_LOG_TIME_CHARS = 8;
  static readonly LOGGER_COLUMN_TIME_DIFF_CHARS = 9;
  static readonly LOGGER_COLUMN_BYTES_CHARS = 8;
  static readonly LOGGER_COLUMN_LOG_ENTRY_NUMBER_CHARS = 4;

  static readonly FILES_TO_IGNORE_ERROR_COLOR_ON_STACKTRACE = ['logger', 'utils_logs.ts', 'utils_asserts', 'builder_log_entry', '.vite', 'node_modules'];
}
